import _ from 'lodash';

export default class Manager {
  constructor(data) {
    this.email = _.get(data, 'email', '');
    this.shops = _.get(data, 'email', []);
  }
}
